export default __webpack_public_path__ + "static/media/marketing.a37ac11d.svg";